<!--
    课程分享-课程批量授权
    作用：第二步：授权方式选择
    说明：版本3.0
-->
<template>
  <div class="step-wrapper">
    <div class="title">请选择授权方式（二选一）</div>
    <div class="radio-demo">
      <el-radio
        v-model="radio"
        class="item"
        label="1">按校区员工账号授权（每个账户默认有效使用课程时长一年）</el-radio>
      <el-radio
        v-model="radio"
        class="item"
        label="2">按课程上课有效次数授权（被授权校区有限使用课程上课次数）</el-radio>
    </div>
    <div class="bottom-btns">
      <el-button @click="lastStep">上一步</el-button>
      <el-button
        type="primary"
        @click="nextStep">下一步</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TwoStep',
  data() {
    return {
      radio: '1',
    };
  },
  methods: {
    lastStep() {
      this.$emit('lastStep');
    },
    nextStep() {
      this.$emit('nextStep', this.radio);
      this.$store.dispatch('setAccountAuth', []);
    },
  },
};
</script>
<style lang="scss" scoped>
.step-wrapper{
    margin: 20px auto;
    width: 70%;
    height: 440px;
    background: #F9FAFC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title{
        padding-bottom: 50px;
    }
    .radio-demo{
       .item{
           display: block;
           margin-bottom: 30px;
       }
    }
    .bottom-btns{
        margin-top: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/twoStep.vue